import { render, staticRenderFns } from "./InquiryModuleDropdown.vue?vue&type=template&id=27dde42f&"
import script from "./InquiryModuleDropdown.vue?vue&type=script&lang=js&"
export * from "./InquiryModuleDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports